import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles'

import { lightTheme, darkTheme, modernTheme } from './theme'
import { useFeatureFlag } from './useFeatureFlag'

/** @type {React.FC<ThemeProviderProps>} */
const ThemeProvider = (props) => {
  const isNewDesignEnabled = useFeatureFlag('new-retailer-design')
  const theme =
    props.mode === 'light'
      ? isNewDesignEnabled
        ? modernTheme
        : lightTheme
      : darkTheme

  return <MuiThemeProvider theme={theme}>{props.children}</MuiThemeProvider>
}

/**
 * @typedef {{
 *  mode: 'light' | 'dark'
 * }} ThemeProviderProps
 */

export default ThemeProvider
